/**
 * Meta (Facebook) Pixel helpers.
 *
 * We keep the Pixel ID in an env var (REACT_APP_META_PIXEL_ID). If not set,
 * every function below is a no-op — so preview/staging never pings Meta and
 * you don't have to guard every call site.
 *
 * Standard events we fire:
 *   • PageView         — every route change
 *   • ViewContent      — landing on /august, /spring, or /
 *   • InitiateCheckout — landing on /booking
 *   • Purchase         — successful Stripe redirect to /payment/success
 *
 * These map to Meta's standard event vocabulary so Ads Manager can optimise
 * for real conversions rather than clicks alone.
 */

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let injected = false;

export function initMetaPixel() {
  if (!PIXEL_ID || injected || typeof window === "undefined") return;

  // Official Meta Pixel base snippet, adapted to inject on demand.
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){
    if(f.fbq)return; n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n; n.push=n; n.loaded=!0; n.version="2.0";
    n.queue=[]; t=b.createElement(e); t.async=!0;
    t.src=v; s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);
  }(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  injected = true;
}

export function fbTrack(event, params) {
  if (!PIXEL_ID || typeof window === "undefined" || !window.fbq) return;
  if (params) window.fbq("track", event, params);
  else window.fbq("track", event);
}

export function fbPageView() {
  fbTrack("PageView");
}
